import { createContext, useState } from 'react'

interface BottomSheetData {
  Component: any
  props?: any
}

interface BottomSheet {
  bottomSheet: BottomSheetData | undefined
  showBottomSheet: (bottomSheet: BottomSheetData) => void
  hideBottomSheet: () => void
}

export const BottomSheetContext = createContext<BottomSheet>({
  bottomSheet: undefined,
  showBottomSheet: () => undefined,
  hideBottomSheet: () => undefined,
})

export const BottomSheetProvider = ({ children }: { children: any }) => {
  const [bottomSheet, setContent] = useState<BottomSheet['bottomSheet']>()

  const showBottomSheet = (bottomSheet: BottomSheet['bottomSheet']) => setContent(bottomSheet)

  const hideBottomSheet = () => setContent(undefined)

  return (
    <BottomSheetContext.Provider value={{ bottomSheet, showBottomSheet, hideBottomSheet }}>
      {children}
    </BottomSheetContext.Provider>
  )
}

export type { BottomSheetData }
